import type { IconGlyph } from '../icon';

import { iconPositionThick } from './position-thick';

/**
 * Tractie `position` glyph (medium, 24×24).
 *
 * Source: `@tractie/icons` v1.5.0, `dist/jsx/m/position.jsx`.
 * Verbatim copy of the SVG `d` attributes, 2 paths in source order.
 */
export const iconPosition: IconGlyph = {
  name: 'position',
  path: [
    'M11.49 6a2.5 2.5 0 0 0 0-5 2.5 2.5 0 0 0 0 5m0-4c.83 0 1.5.67 1.5 1.5S12.32 5 11.49 5s-1.5-.67-1.5-1.5.67-1.5 1.5-1.5m-4 12c.28 0 .5-.22.5-.5V9.39c0-.77.62-1.39 1.39-1.39h4.21c.77 0 1.39.62 1.39 1.39v4.11c0 .28.22.5.5.5s.5-.22.5-.5V9.39A2.39 2.39 0 0 0 13.59 7H9.38a2.39 2.39 0 0 0-2.39 2.39v4.11c0 .28.22.5.5.5m9.4 3.01h-.01c-.27-.04-.52.16-.56.43s.16.53.43.56c4.31.57 5.24 1.62 5.24 1.85 0 .73-3.53 2.15-10 2.15s-10-1.42-10-2.14c0-.36 1.32-1.33 5.24-1.86.27-.04.47-.29.43-.56a.503.503 0 0 0-.56-.43c-1.84.25-6.1 1.02-6.1 2.85C1 22.17 7.58 23 12 23s11-.84 11-3.15c0-1.29-2.23-2.33-6.11-2.84',
    'M8.99 14.5v6c0 .28.22.5.5.5s.5-.22.5-.5v-6c0-.28-.22-.5-.5-.5s-.5.22-.5.5m4 0v6c0 .28.22.5.5.5s.5-.22.5-.5v-6c0-.28-.22-.5-.5-.5s-.5.22-.5.5',
  ],
  selected: iconPositionThick,
};
